module.exports = __webpack_public_path__ + "img/hardhat.638ceb77.svg";